import "../css/LoginGlass01.css";
// import LogoColor from "../media/images/icons/logos.png";
import LogoColor from "../assets/img/logo/corob.png";
import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import Session from "react-session-api";
import UseFetchData from "../hooks/UseFetchData";
import ReCAPTCHA from "react-google-recaptcha";
import BiztranControls from "./biztran_controls/BiztranControls";
import Link from '@mui/material/Link';



let isFirst = true;
const LoginGlass = () => {
  const [response, fetchData] = UseFetchData();
  const [errortext, setErrortext] = useState("");
  const [UserName, setUserName] = useState("");
  const [ForgotPass, setForgotPass] = useState(false);
  const [ReCAPTCHAValidate, setReCAPTCHAValidate] = useState(false);
  useEffect(() => {
    // var form = document.getElementById("loginform");
    // form.addEventListener("mousemove", (e) => {
    //   var x = (window.innerWidth / 2 - e.pageX) / 12;
    //   var y = (window.innerHeight / 2 - e.pageY) / 12;
    //   form.style.transform = "rotateX(" + x + "deg) rotateY(" + y + "deg)";
    // });

    // form.addEventListener("mouseleave", function () {
    //   form.style.transform = "rotateX(0deg) rotateY(0deg)";
    // });
  }, []);

  function onChange(value) {
    console.log("Captcha value:", value);
    if (value !== "") {
      setReCAPTCHAValidate(true);
    }
  }

  function forgotPassword() {
    setForgotPass(true);
  }
  const PopulateData = (values) => {
    console.log("submitted", values.userName);

  };

  useEffect(() => {
    setErrortext("");
    debugger;
    if (response.length > 0) {
      debugger;
      Session.set("UID", response[0].UserID);
      Session.set("UserName", response[0].UserName);
      if (response[0].UserType == "Employee") {
        Session.set("UserType", "Employee");
      }
      else if (response[0].UserType == "Manager" && response[0].UserID == '6207ea82-dafc-4463-b262-9ef8dbe08366') {
        Session.set("UserType", "CFO");
      } else if (response[0].UserType == "Manager") {
        Session.set("UserType", "Manager")
      }
      else {
        Session.set("UserType", "Admin");
      }

      // Session.set("UserType", response[0].UserType);
      Session.set("FilePath", response[0].FilePath);
      Session.set("Email", response[0].Email);
      Session.set("EmailPassword", response[0].EmailPassword);
      Session.set("CompanyName", response[0].CompanyName);
      Session.set("CompanyID", response[0].CompanyID);
      Session.set("CategoryID", response[0].CategoryID);
      isFirst = true;
    } else if (isFirst === false) {
      setErrortext("Invalid Username or Password");
    } else if (response.Response === true) {
      alert("Password Send To your Mail");
    }
  }, [response]);
  return (
    <Formik
      initialValues={{ userName: "", Password: "" }}
      validationSchema={Yup.object({
        userName: Yup.string().required("Required"),
        ///passWord: Yup.string().required("Required"),
      })}
      onSubmit={(values, { setSubmitting }) => {
        if (ReCAPTCHAValidate === true) {
          setSubmitting(false);
          isFirst = false;
          var bodyFormData = new FormData();
          bodyFormData.append("UserName", values.userName);
          bodyFormData.append("Password", values.Password);
          console.log("Inside Login");
          fetchData("User/Login", bodyFormData);
        }
        else if (ForgotPass === true) {
          debugger;
          console.log(ForgotPass)
          var bodyFormData = new FormData();
          console.log(values.userName);
          bodyFormData.append("FromEmail", "akhil.b@biztransolutions.com");
          bodyFormData.append("SenderPassword", "Biz@icewarp12");
          bodyFormData.append("Subject", "Password");
          bodyFormData.append("UserName", values.userName);
          fetchData("User/MailSend", bodyFormData);
        }

      }}
    >
      <div className="form-container">
        <Form id="loginform">
          <img src={LogoColor} alt="PM Logo" className="logo" />
          <section className="container" />
          <span className="icon">
            <i className="fas fa-user"></i>
          </span>
          <Field
            component="input"
            name="userName"
            label="Username"
            placeholder="Username"
            autoComplete="off"
          />
          <div className="container">
            <span className="icon">
              <i className="fas fa-lock"></i>
            </span>
            <Field
              name="Password"
              label="Password"
              type="Password"
              placeholder="Password"
            />
            <br></br>
            {/* <Link
              component="button" type="submit"
              //href="#" underline="always"
              variant="body2"
              onClick={() => {
                forgotPassword();
              }}
            >
              Forgot Password
            </Link> */}
            <ReCAPTCHA
              style={{ marginLeft: '2rem' }}
              // sitekey=""
              sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
              onChange={onChange}
            />
          </div>
          {errortext != "" ? (
            <label className="errorTextStyle">{errortext}</label>
          ) : null}
          <input type="submit" value="SIGN IN" />
        </Form>
      </div>
    </Formik>
  );
};

export default LoginGlass;
